import type { SVGProps } from 'react';
export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M9.21 4.35a4.85 4.85 0 1 0 0 9.71 4.85 4.85 0 0 0 0-9.7M3 9.21a6.21 6.21 0 1 1 11.05 3.89l2.75 2.74a.68.68 0 0 1-.96.96l-2.74-2.75A6.21 6.21 0 0 1 3 9.21"
      clipRule="evenodd"
    />
  </svg>
);
